import { removerCaracteresEspeciais } from '../../util/formatters/stringNormalizer';

export const tiposFiltroTabela = {
  filtrarPergunta: 'filtrarPergunta',
  filtrarAlternativa: 'filtrarAlternativa',
};

const filterStrategies = {
  filtrarPergunta: (perguntasCruzadas, keywords) => {
    if (!keywords || keywords.length === 0) return perguntasCruzadas;
    return perguntasCruzadas.filter((pergunta) => removerCaracteresEspeciais(pergunta.enunciado)
      .toLowerCase().includes(removerCaracteresEspeciais(keywords).toLowerCase()));
  },
  filtrarAlternativa: (perguntasCruzadas, keywords) => {
    if (!keywords || keywords.length === 0) return perguntasCruzadas;
    const resultadoFiltragem = [];
    perguntasCruzadas.forEach((pergunta) => {
      const alternativasMatch = pergunta.alternativas.filter((alternativa) => removerCaracteresEspeciais(alternativa.enunciado)
        .toLowerCase().includes(removerCaracteresEspeciais(keywords).toLowerCase()));
      if (alternativasMatch.length > 0) {
        const perguntaFiltrada = { ...pergunta };
        perguntaFiltrada.alternativas = alternativasMatch;
        resultadoFiltragem.push(perguntaFiltrada);
      }
    });
    return resultadoFiltragem;
  },
};

export function filterData(perguntasCruzadas, filter) {
  const resultadoFiltragem = filterStrategies[filter.type](
    perguntasCruzadas,
    filter.keywords,
  );
  return resultadoFiltragem;
}
